export const U={"LB->OZ":16,"LB->G":453.592,"OZ->G":28.3495,"OZ->TSP":6,"OZ->TBS":2,"TBS->TSP":3,"GAL->OZ":128,"OZ->GAL":1/128,"G->OZ":1/28.3495,"G->LB":1/453.592,"OZ->LB":1/16,"TSP->TBS":1/3,"TSP->OZ":1/6,"TBS->OZ":0.5,"FL OZ->OZ":1,"EACH->EACH":1,"EACH->SLICE":1,"EACH->SERVING":1,"EACH->PIECE":1,"EACH->CT":1,"SLICE->EACH":1,"SLICE->SLICE":1,"SLICE->SERVING":1,"SLICE->PIECE":1,"SLICE->CT":1,"SERVING->EACH":1,"SERVING->SLICE":1,"SERVING->SERVING":1,"SERVING->PIECE":1,"SERVING->CT":1,"PIECE->EACH":1,"PIECE->SLICE":1,"PIECE->SERVING":1,"PIECE->PIECE":1,"PIECE->CT":1,"CT->EACH":1,"CT->SLICE":1,"CT->SERVING":1,"CT->PIECE":1,"CT->CT":1,"BAG->BAG":1,"DOZEN->EACH":12,"DOZEN->SLICE":12,"DOZEN->SERVING":12,"DOZEN->PIECE":12,"DOZEN->CT":12,"QUART->OZ":32,"OZ->QUART":1/32,"QUART->QUART":1,"LITERS->OZ":33.814,"OZ->LITERS":1/33.814,"ML->OZ":0.033814,"OZ->ML":1/0.033814,"LITERS->ML":1000,"LITERS->LITERS":1,"ML->ML":1,"LB->LB":1,"OZ->OZ":1,"G->G":1,"GAL->GAL":1,"TBS->TBS":1,"TSP->TSP":1};

export function cv(q,f,t2){if(f===t2)return q;let k=f+"->"+t2;if(U[k])return q*U[k];k=t2+"->"+f;if(U[k])return q/U[k];const a=f+"->OZ",b="OZ->"+t2;if(U[a]&&U[b])return q*U[a]*U[b];return null;}

export function gu(i,u){
  if(!i?.cp||!i?.cq||i.cq===0)return 0;
  const yp=i.yp||100;

  // Servings path: cp / srv gives cost per serving in sru units
  if(i.srv&&i.srv>0){
    if(i.sru){
      // Typed servings: use when target matches sru or converts from sru
      if(u===i.sru)return i.cp/i.srv/yp*100;
      const srvConv=cv(1,i.sru,u);
      if(srvConv!==null)return i.cp/i.srv/yp*100/srvConv;
    }else{
      // Legacy: no servings_unit set — old behavior (bypass unit check)
      return i.cp/i.srv/yp*100;
    }
  }

  // Base: cost per cu unit
  const r2=i.cp/i.cq/yp*100;
  if(i.cu===u)return r2;

  // Standard conversion table
  const x=cv(1,i.cu,u);
  if(x!==null)return r2/x;

  return null;
}

export const UL=["EACH","DOZEN","SLICE","SERVING","BAG","OZ","LB","G","GAL","QUART","LITERS","ML","TBS","TSP"];
